import React from 'react';
import { SectionHeading } from './SectionHeading';
import { afterPurchase, bonuses, mockupImage } from '../data/offer';
export function AfterPurchase() {
  return <section className="w-full bg-carbon-800 py-16 sm:py-20 lg:py-28" aria-labelledby="after-heading" data-id="element-19" data-mp="21w0ldtb4caae">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-20" data-mp="2bnwo5ho5goky">
        <SectionHeading id="after-heading" eyebrow="After the purchase" title={<>
              This is exactly what
              <span className="block text-mint" data-id="element-22" data-mp="2llb2nbqij3am">lands in your inbox</span>
            </>} subtitle="No shipping, no waiting, no login courses. Six PDF files, delivered by email in seconds." data-id="element-21" data-mp="2bphhx52n43hr" />

        <div className="mt-12 grid grid-cols-1 gap-8 sm:mt-14 sm:gap-10 lg:grid-cols-[1fr_0.9fr] lg:gap-16" data-id="element-23" data-mp="2umiogubuebnt">
          <ol className="space-y-5 sm:space-y-6" data-id="element-24" data-mp="vbrbhro1t34y">
            {afterPurchase.map(item => <li key={item.step} className="flex gap-5 rounded-xl border border-carbon-line bg-carbon-900 p-6" data-id="element-25" data-mp="1099mropjfug4">
                <span className="font-display text-2xl leading-none text-mint" aria-hidden="true" data-id="element-26" data-mp="s10ajnz7b2e7">
                  {item.step}
                </span>
                <div data-id="element-27" data-mp="nxkht2q95m6s">
                  <h3 className="font-display text-lg uppercase text-paper" data-id="element-28" data-mp="j0k7gfmddx9v">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-paper-dim" data-id="element-29" data-mp="1fqulu13vgiwc">{item.description}</p>
                </div>
              </li>)}
          </ol>

          <div className="rounded-2xl border border-carbon-line bg-carbon-900 p-4" data-id="element-30" data-mp="1bpr8pmd7l0yt">
            <img src={mockupImage} alt="The complete pack and its five bonus PDFs displayed on screens" className="w-full rounded-xl object-cover" loading="lazy" data-id="element-31" data-mp="16p3eysxli60w" />
            <ul className="mt-5 grid grid-cols-3 gap-2 sm:grid-cols-5" data-id="element-32" data-mp="3reaq5o9b4bbn">
              {bonuses.map(bonus => <li key={bonus.title} data-id="element-33" data-mp="3mjn92agmuj73">
                  <img src={bonus.image} alt={`${bonus.title} cover`} className="aspect-square w-full rounded-md object-cover" loading="lazy" data-id="element-34" data-mp="3ny7t9keib01i" />
                </li>)}
            </ul>
            <p className="mt-5 text-center text-xs uppercase tracking-[0.16em] text-paper-dim" data-id="element-35" data-mp="3jw33wxv3cpko">
              6 PDF files — no video, no audio, nothing shipped
            </p>
          </div>
        </div>
      </div>
    </section>;
}